<template>
  <v-card>
    <v-card-text>
      <v-container container--fluid grid-list-md>
        <v-row justify="space-between">
          <v-col cols="12" sm="12" md="6" v-for="(item, index) in items" :key="index">
            <v-switch
              v-model="clientInfo[item.key]"
              :label="item.text"
            ></v-switch>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
// @group EditClient
// Client Accounting Information tab for EditClient
export default {
  name: "ClientLinehaulSetting",
  props: {
    // Client Object
    clientInfo: Object,
  },
  data() {
    return {
      items: [
        {text: 'Linehaul Restricted', key: 'linehaul_restricted', type: 'switch'},
      ]
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ClientLinehaulSetting.vue